export default "__VITE_ASSET__CXAEfDl3__"